module.exports = __webpack_public_path__ + "img/discover.1324323.png";